export const ru = {
    'action-unsubscribe': 'Отписать',
    description: 'Добавьте пользователей, которых хотите подписать на обновления страницы или раздела. Уведомления об обновлениях будут приходить подписчикам на почту.',
    'empty-title': 'У страницы нет подписчиков',
    'error-add-subscribers': 'Не удалось добавить подписчиков',
    'error-add-subscribers-forbidden': 'Невозможно подписать пользователя, у которого нет доступа к странице',
    'error-add-subscribers-subscribed': 'Пользователь уже подписан на страницу или раздел',
    'error-del-subscribers': 'Не удалось отписать пользователей',
    'error-get-subscribers': 'Не удалось загрузить список подписчиков',
    placeholder: 'Имя или логин сотрудника',
    'subscription-to-cluster': 'На раздел',
    'subscription-to-page': 'На страницу',
    title: 'Подписка на обновления'
};
